import { Cloudinary } from "@cloudinary/url-gen";

// Replace 'your-cloud-name' with your actual Cloudinary cloud name
export const cld = new Cloudinary({
  cloud: {
    cloudName: "ddza3qui6",
  },
});
